"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledViewModeButton = exports.StyledTablePaginationContainer = exports.StyledTableContainer = exports.StyledTable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../../ykb-styled-components");
var _StyledButton = _interopRequireDefault(require("../../Button/StyledButton"));
var _StyledCheckbox = require("../../Checkbox/StyledCheckbox");
var _StyledRadio = require("../../Radio/StyledRadio");
var _StyledTableWrapper = require("./StyledTableWrapper");
var _StyledIcon = _interopRequireDefault(require("../../Icon/StyledIcon"));
var _StyledTextInput = require("../../TextInput/StyledTextInput");
var _StyledNumericInput = require("../../NumberInput/StyledNumericInput");
var _StyledInputHoc = require("../../Form/styled/StyledInputHoc");
var _StyledTableComponents = require("./StyledTableComponents");
var _excluded = ["prefixCls", "children", "className", "theme", "minHeight"];
//#region bordered
var BorderedTable = (0, _ykbStyledComponents.css)([".", "{> ", "-title{border:", ";border-bottom:0;}> .", "-container{border:", ";border-right:0;border-bottom:", ";> .", "-body,.", "-content{", "}> .", "-content,> .", "-header,> .", "-body{> table{> thead > tr > th,> tbody > tr > td,> tfoot > tr > th,> tfoot > tr > td{border-right:", ";}/ > thead{> tr:not(:last-child) > th{border-bottom:", ";}}> thead > tr,> tbody > tr,> tfoot > tr{> .", "-cell-fix-right-first::after{border-right:", ";}}}> table > tbody > tr > td{> .", "-expanded-row-fixed{margin:-", " -", "px;&::after{position:absolute;top:0;right:", ";bottom:0;border-right:", ";content:'';}}}}}&.", "-scroll-horizontal{> .", "-container > .", "-body{> table > tbody{> tr.", "-expanded-row,> tr.", "-placeholder{> td{border-right:0;}}}}}.", ".", "-middle{> .", "-container{> .", "-content,> .", "-body{> table > tbody > tr > td{> .", "-expanded-row-fixed{margin:-", " -", "px;}}}}}.", ".", "-middle{> .", "-container{> .", "-content,> .", "-body{> table > tbody > tr > td{> .", "-expanded-row-fixed{margin:-", " -", "px;}}}}}> .", "-footer{border:", ";border-top:0;}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  var _props$scroll;
  return !((_props$scroll = props.scroll) !== null && _props$scroll !== void 0 && _props$scroll.y) && 0;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return !!props.$minHeight && "min-height: ".concat(props.$minHeight, "px;");
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return parseInt(props.theme.table.paddingHorizontal) - parseInt(props.theme.table.borderWidth);
}, function (props) {
  return props.theme.table.borderWidth;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return parseInt(props.theme.table.paddingHorizontal) - parseInt(props.theme.table.borderWidth);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return parseInt(props.theme.table.paddingHorizontal) - parseInt(props.theme.table.borderWidth);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
});
//#endregion

//#region sorter
var sorterCss = (0, _ykbStyledComponents.css)([".", "-thead .", "-column-has-sorters{.", "-column-sorter{display:table-cell;vertical-align:middle;.", "-column-sorter-inner{height:1em;margin-left:5px;color:", ";line-height:1em;text-align:center;transition:all 0.3s;.", "-column-sorter-up,.", "-column-sorter-down{display:inline-block;font-size:12px;:root &{font-size:12px;}display:block;height:1em;line-height:1em;transition:all 0.3s;&.on{color:", ";&:hover:{color:", ";}}}&-full{margin-top:-0.35em;.", "-column-sorter-up,.", "-column-sorter-down{height:1em;line-height:1em;color:", ";&:hover{color:", ";}}.", "-column-sorter-up{margin-top:-0.68em;}.", "-column-sorter-down{margin-top:-1em;top:8px;position:relative;}}}}.", "-header-column{display:inline-block;vertical-align:top;width:100%;.", "-column-sorters{display:table;> .", "-column-title{display:table-cell;vertical-align:middle;}> *:not(.", "-column-sorter){position:relative;}&::before{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;transition:all 0.3s;content:'';}&:hover::before{background:rgba(0,0,0,0.04);}}}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.sort.iconColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.sort.iconSelectedColor;
}, function (props) {
  return props.theme.table.header.sort.iconSelectedColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.sort.iconColor;
}, function (props) {
  return props.theme.table.header.sort.iconHoverColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
});

//#endregion

//#region filter
var filterCss = (0, _ykbStyledComponents.css)([".", "-thead tr th.", "-column-has-filters{.", "-filter-icon{position:absolute;top:0;right:0;padding:0px 3px;width:26px;height:100%;background-color:", ";color:", ";font-size:", "px;text-align:center;cursor:pointer;transition:all 0.3s;display:flex;justify-content:center;align-items:center;&:hover{color:", ";background-color:", ";}&-open{color:", ";}&-selected{color:", " !important;}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.filter.backgroundColor;
}, function (props) {
  return props.theme.table.header.filter.iconColor;
}, function (props) {
  return props.theme.table.header.filter.iconSize;
}, function (props) {
  return props.theme.table.header.filter.iconHoverColor;
}, function (props) {
  return props.theme.table.header.filter.hover.backgroundColor;
}, function (props) {
  return props.theme.table.header.filter.iconHoverColor;
}, function (props) {
  return props.theme.table.header.filter.iconSelectedColor;
});
//#endregion

//#region actions
var actionsCss = (0, _ykbStyledComponents.css)([".", "-thead{.", "-column-has-actions{position:relative;background-clip:padding-box;&.", "-column-has-filters{padding-right:28px !important;&:hover{.", "-filter-icon{&:hover{background:", ";color:", ";}&:active{color:", ";}}}}&.", "-column-has-sorters{cursor:pointer;&:hover{background:", ";color:", ";.", "-filter-icon{background:", ";&:hover{background:", ";}}}&:active{.", "-column-sorter-up:not(.on),.", "-column-sorter-down:not(.on){color:", ";}}}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.filter.hover.backgroundColor;
}, function (props) {
  return props.theme.table.header.filter.hover.color;
}, function (props) {
  return props.theme.table.header.filter.iconHoverColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.sort.active.backgroundColor;
}, function (props) {
  return props.theme.table.header.sort.active.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.filter.backgroundColor;
}, function (props) {
  return props.theme.table.header.filter.hover.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.sort.iconHoverColor;
});

//#endregion

//#region selection
var selectionCss = (0, _ykbStyledComponents.css)([".", "-selection{white-space:nowrap;text-align:center;&-select-all-custom{margin-right:", " !important;}.", "-icon-down{color:", ";transition:all 0.3s;}.", "-menu{min-width:96px;margin-top:5px;margin-left:-30px;background:", ";border-radius:", ";box-shadow:", ";.", "-action-down{color:", ";}}&-down{display:inline-block;padding:0;line-height:1;cursor:pointer;color:", ";vertical-align:middle;font-size:", ";&:hover,.", "-icon-down{color:", ";}", "{vertical-align:baseline;}}}colgroup{> col.", "-selection-col{width:", ";&.", "-selection-col-custom{width:", ";}}}.", "-thead > tr > th.", "-selection-column-custom{padding:", ";.", "-selection{margin-right:-", ";}}.", "-thead > tr > th.", "-selection-column,.", "-tbody > tr > td.", "-selection-column,tfoot > tr > td.", "-selection-column{text-align:center;max-width:", ";min-width:", ";", ",", "{text-align:center;margin:0;}}.", "-row[class*='", "-row-level-0'] .", "-selection-column > span{display:inline-block;}.", "-tbody > tr.row-selected,.", ".zebra .", "-tbody > tr.row-selected{> td{color:", ";background-color:", ";}&:hover{> td{color:", ";background-color:", ";}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.selectAll.label.marginRight;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.iconColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.component.background;
}, function (props) {
  return props.theme.component.borderRadius;
}, function (props) {
  return props.theme.component.shadow;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.iconColor;
}, function (props) {
  return props.theme.table.selection.iconColor;
}, function (props) {
  return props.theme.table.selection.iconSize;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.iconHoverColor;
}, _StyledIcon.default, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.width;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.width;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.selectAll.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.selectAll.marginRight;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.selection.width;
}, function (props) {
  return props.theme.table.selection.width;
}, _StyledCheckbox.StyledCheckbox, _StyledRadio.StyledRadio, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.row.selected.color;
}, function (props) {
  return props.theme.table.row.selected.backgroundColor;
}, function (props) {
  return props.theme.table.row.selected.hover.color;
}, function (props) {
  return props.theme.table.row.selected.hover.backgroundColor;
});

//#endregion

//#region expandableRow
var expandableRow = (0, _ykbStyledComponents.css)([".", "-expand-icon-th,.", "-row-expand-icon-cell{width:", ";min-width:", ";text-align:center;}.", "-row{&-expand-icon{display:inline-block;text-align:center;width:", ";height:", ";border-width:1px;padding:1px;border-style:solid;border-radius:", ";border-color:", ";background-color:", ";cursor:pointer;user-select:none;", "{color:", ";vertical-align:top;}}&-spaced{visibility:hidden;}}tr.", "-expanded-row{> td > div", "{background-color:", ";margin:-", " -", " -", " ", "px;margin-bottom:calc(-", " - 1px);.", "-container{border-top:0;.", "-tbody{> tr > td.", "-cell:last-child{border-right:0 !important;}}.", "-thead{> tr > th.", "-cell:last-child{border-right:0 !important;}}.", "-tbody > tr:last-child > td{&:first-child,&:last-child{border-radius:0;}}}}}.", "-row-indent + .", "-row-expand-icon{margin-right:8px;}.", "-expanded-row-fixed{position:relative;margin:-", " -", ";padding:", " ", ";}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.row.expender.col.width;
}, function (props) {
  return props.theme.table.row.expender.col.width;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.size;
}, function (props) {
  return props.theme.checkbox.check.size;
}, function (props) {
  return props.theme.checkbox.check.borderRadius;
}, function (props) {
  return props.theme.checkbox.check.status.default.borderColor;
}, function (props) {
  return props.theme.checkbox.check.status.default.backgroundColor;
}, _StyledIcon.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.prefixCls;
}, _StyledTableWrapper.StyledTableWrapper, function (props) {
  return props.theme.table.header.backgroundColor;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return parseInt(props.theme.table.row.expender.col.width) - 1 - parseInt(props.theme.table.paddingHorizontal);
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
});
//#endregion

var StyledViewModeButton = exports.StyledViewModeButton = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-wkeoxa-0"
})(["", ";min-height:", ";height:", ";padding:", ";line-height:calc(", " - 1px);", ";"], _StyledInputHoc.ViewModeValueMixin, function (props) {
  return props.theme.button.size.small.height;
}, function (props) {
  return props.theme.button.size.small.height;
}, function (props) {
  return props.theme.button.size.small.padding;
}, function (props) {
  return props.theme.button.size.small.height;
}, _StyledInputHoc.EllipsisMixin);

//#region table sizes

var tableSize = function tableSize(size) {
  if (size !== 'middle' && size !== 'small') return '';
  return (0, _ykbStyledComponents.css)([".", ".", "-", "{font-size:", ";.", "-tbody > tr > .editing-cell{padding:", " ", " !important;}.", "-title,.", "-thead > tr > th,.", "-tbody > tr > td,tfoot > tr > th,tfoot > tr > td{padding:", " ", " !important;}.", "-footer{padding:0 ", " !important;}.", "-thead{th.", "-column-has-sorters{padding:0;}.", "-filter-column{margin:-", " -", ";}.", "-filter-column-title{padding:", " 2.3em ", " ", ";}.", "-column-sorters{padding:0px ", " 0px 0px;}}.", "-expanded-row-fixed{margin:-", " -", ";}.", "-tbody{.", "-wrapper:only-child{.", "{margin:-", " -", " -", " -", ";}}}tr.", "-measure-row td{padding:0 !important;margin:0 !important;}}", ""], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, size, function (props) {
    return props.theme.table[size].fontSize;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table.small.editable.paddingVertical;
  }, function (props) {
    return props.theme.table.small.editable.paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.theme.table[size].paddingVertical;
  }, function (props) {
    return props.theme.table[size].paddingHorizontal;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.size === 'small' && (0, _ykbStyledComponents.css)([".", "-small{.", "-selection-col{width:", ";min-width:", ";&.", "-selection-col-custom{width:", ";min-width:", ";}}}.", "-expand-icon-th,.", "-row-expand-icon-cell{width:", ";min-width:", ";}tr.", "-expanded-row{> td > div", "{margin:-", " -", " -", " ", "px;margin-bottom:calc( -", " - 1px );}}", ".table-action-button{margin:-1px -2px;height:", ";}.", ".editable-cell,.", ".editable-row{tr > td.", "-cell{", ".editable-cell-button{padding:", ";height:", ";}", "{min-height:", ";height:", ";padding:", ";line-height:calc( ", " - 2 * ", " );}}}", ";"], function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.theme.table.selection.small.width;
    }, function (props) {
      return props.theme.table.selection.small.width;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.theme.table.selection.width;
    }, function (props) {
      return props.theme.table.selection.width;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.theme.table.row.expender.col.small.width;
    }, function (props) {
      return props.theme.table.row.expender.col.small.width;
    }, function (props) {
      return props.prefixCls;
    }, _StyledTableWrapper.StyledTableWrapper, function (props) {
      return props.theme.table.small.paddingVertical;
    }, function (props) {
      return props.theme.table.small.paddingHorizontal;
    }, function (props) {
      return props.theme.table.small.paddingVertical;
    }, function (props) {
      return parseInt(props.theme.table.row.expender.col.small.width) - parseInt(props.theme.table.small.paddingHorizontal);
    }, function (props) {
      return props.theme.table.small.paddingVertical;
    }, _StyledButton.default, function (props) {
      return props.theme.table.action.small.height;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.prefixCls;
    }, function (props) {
      return props.prefixCls;
    }, _StyledButton.default, function (props) {
      return props.theme.button.size.xsmall.padding;
    }, function (props) {
      return props.theme.button.size.xsmall.height;
    }, StyledViewModeButton, function (props) {
      return props.theme.button.size.xsmall.height;
    }, function (props) {
      return props.theme.button.size.xsmall.height;
    }, function (props) {
      return props.theme.button.size.xsmall.padding;
    }, function (props) {
      return props.theme.button.size.xsmall.height;
    }, function (props) {
      return props.theme.button.size.xsmall.borderWidth;
    }, _StyledTableComponents.tableXsmallComponents);
  });
};

//#endregion

//#region fixed
var fixedCss = (0, _ykbStyledComponents.css)([".", "-cell-fix-left,.", "-cell-fix-right{position:-webkit-sticky !important;position:sticky !important;z-index:", ";background:", ";}.", "-cell-fix-left-first::after,.", "-cell-fix-left-last::after{position:absolute;top:0;right:0;bottom:-1px;width:30px;transform:translateX(100%);transition:box-shadow 0.3s;content:'';pointer-events:none;}.", "-cell-fix-right-first::after,.", "-cell-fix-right-last::after{position:absolute;top:0;bottom:-1px;left:0;width:30px;transform:translateX(-100%);transition:box-shadow 0.3s;content:'';pointer-events:none;}.", "-container{&::before,&::after{position:absolute;top:0;bottom:0;z-index:1;width:30px;transition:box-shadow 0.3s;content:'';pointer-events:none;}&::before{left:0;}&::after{right:0;", "}}.", "-ping-left{&:not(.", "-has-fix-left) .", "-container{position:relative;&::before{box-shadow:inset 10px 0 8px -8px ", ";}}.", "-cell-fix-left-first::after,.", "-cell-fix-left-last::after{box-shadow:inset 10px 0 8px -8px ", ";}}.", "-ping-right{&:not(.", "-has-fix-right) .", "-container{position:relative;&::after{box-shadow:inset -10px 0 8px -8px ", ";}}.", "-cell-fix-right-first::after,.", "-cell-fix-right-last::after{box-shadow:inset -10px 0 8px -8px ", ";}}.", "-sticky{.", "-header{position:sticky;z-index:", ";}.", "-scroll{position:sticky;bottom:0;z-index:", ";display:flex;align-items:center;background:", ";border-top:1px solid ", ";opacity:0.6;&:hover{transform-origin:center bottom;}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.zIndex;
}, function (props) {
  return props.theme.table.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.bordered ? "\n      border-right: ".concat(function (props) {
    return props.theme.table.borderWidth;
  }, "\n      ").concat(function (props) {
    return props.theme.table.borderStyle;
  }, "\n      ").concat(function (props) {
    return props.theme.table.borderColor;
  }, ";") : '';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.shadowColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.shadowColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.shadowColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.shadowColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.zIndex;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.sticky.zIndex;
}, function (props) {
  return props.theme.color.default5;
}, function (props) {
  return props.theme.table.borderColor;
});

//#endregion

//#region editable

var editableCss = (0, _ykbStyledComponents.css)([".", ".editable-cell,.", ".editable-row{", "{display:none;}", "{min-width:unset;width:100%;}", ".table-input{min-width:unset;width:100%;}.", "-body,.", "-content{position:", ";}tr > td.", "-cell{position:inherit;", ".editable-cell-button{padding:", " ", ";height:", ";font-size:", ";border:", ";border-radius:", ";transition:all 0.3s;width:100%;text-align:left;overflow:hidden;text-overflow:ellipsis;&:focus{border-color:", ";outline:0;box-shadow:0 0 3px 3px ", ";border-right-width:1px !important;}&:disabled{background-color:", ";}}}}", "{min-height:", ";height:", ";padding:", ";line-height:calc(", " - 1px);}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, _StyledInputHoc.StyledInputHocError, _StyledNumericInput.StyledNumericInputContainer, _StyledTextInput.StyledInput, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.$isEditMode ? 'relative' : '';
}, function (props) {
  return props.prefixCls;
}, _StyledButton.default, function (props) {
  return props.theme.input.sizes.small.paddingVertical;
}, function (props) {
  return props.theme.input.sizes.small.paddingHorizontal;
}, function (props) {
  return props.theme.input.sizes.small.height;
}, function (props) {
  return props.theme.input.sizes.small.fontSize;
}, function (props) {
  return props.theme.input.sizes.small.border;
}, function (props) {
  return props.theme.input.sizes.small.borderRadius;
}, function (props) {
  return props.theme.input.focus.borderColor;
}, function (props) {
  return props.theme.input.focus.boxShadowColor;
}, function (props) {
  return props.theme.color.default2;
}, _StyledInputHoc.StyledViewModeValue, function (props) {
  return props.theme.button.size.small.height;
}, function (props) {
  return props.theme.button.size.small.height;
}, function (props) {
  return props.theme.button.size.small.padding;
}, function (props) {
  return props.theme.button.size.small.height;
});

//#endregion

var StyledTableContainer = exports.StyledTableContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-wkeoxa-1"
})(["position:relative;clear:both;", ";z-index:", ";font-size:", ";background:", ";border-radius:", ";.", "-body,.", "-content{transition:opacity 0.3s;position:relative;colgroup{min-width:auto !important;col{min-width:auto !important;}}}.", "-  .", "-body,.", "-empty .", "-content{overflow:auto !important;}table{width:100%;text-align:left;border-radius:", " ", " 0 0;border-collapse:separate;border-spacing:0;}.", "-thead > tr > th,.", "-tbody > tr > td,tfoot > tr > th,tfoot > tr > td{position:relative;padding:", " ", ";overflow-wrap:break-word;}.", "-cell-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-break:keep-all;}.", "-cell-ellipsis.", "-cell-fix-left-last,.", "-cell-ellipsis.", "-cell-fix-right-first{overflow:visible;.", "-cell-content{display:block;overflow:hidden;text-overflow:ellipsis;}}.", "-thead{> tr{> th{color:", ";font-size:", ";font-weight:", ";text-align:", ";background:", ";border-bottom:", ";transition:background 0.3s ease;&[colspan]:not([colspan='1']){text-align:center;}}}.", "-column-without-sorters{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}}.", "-tbody{> tr{", " > th{border-right:", ";padding:", " ", " ", " ", ";color:", ";font-size:", ";font-weight:", ";text-align:", ";background:", ";border-bottom:", ";transition:background 0.3s ease;&[colspan]:not([colspan='1']){text-align:center;}}> th,> td{border-bottom:", ";transition:background 0.3s;> .", "-wrapper:only-child{.", "{margin:-", " -", " -", " ", ";.", "-tbody > tr:last-child > td{border-bottom:0;&:first-child,&:last-child{border-radius:0;}}}}}&.editing-row.", "-row{.editable-cell-button{background-color:", ";}}&.", "-row:hover{> th,> td{background:", ";}:hover{.editable-cell-button{background-color:", " !important;}}}}}tfoot{> tr{> th,> td{border-bottom:", ";}}}.", "-footer{", ";position:relative;padding:0 ", ";border-top:", ";border-radius:0 0 ", " ", ";z-index:", ";&:empty{display:none;}&::before{position:absolute;top:-1px;left:0;width:100%;height:1px;background:", ";content:'';}&-content{padding:", " ", ";}}.", "-pagination{display:flex;justify-content:flex-end;margin:16px 0;}.", "-pagination-left{justify-content:flex-start;}.", "-pagination-center{justify-content:center;}.", "-pagination-right{justify-content:flex-end;}.", ".zebra:not(.", "-scroll-horizontal){.", "-tbody,.", "-tfoot{> tr:not(.", "-expanded-row):not(.row-selected):nth-child(even){> td{background-color:", ";color:", ";}&:hover{> td{background:", ";}}}}}.", ".zebra.", "-scroll-horizontal{.", "-tbody,.", "-tfoot{> tr:not(.", "-expanded-row):not(.row-selected):nth-child(odd){> td{background-color:", ";color:", ";}&:hover{> td{background:", ";}}}}}.", "-title{position:relative;top:1px;padding:", " 0;border-radius:", " ", " 0 0;font-size:", ";font-weight:", ";color:", ";}.", ".bordered .", "-title{padding-right:", ";padding-left:", ";border:", ";}.", ".primary >{.", "-container > .", "-content > table > .", "-thead,.", "-container > .", "-header > table > .", "-thead{tr > th{background:", ";color:", ";}}}.", ".success >{.", "-container > .", "-content > table > .", "-thead,.", "-container > .", "-header > table > .", "-thead{tr > th{background:", ";color:", ";}}}.", ".danger >{.", "-container > .", "-content > table > .", "-thead,.", "-container > .", "-header > table > .", "-thead{tr > th{background:", ";color:", ";}}}.", "-title + .", "-content{position:relative;overflow:hidden;border-radius:", " ", "  0 0;.", ".bordered{table,.", "-thead > tr:first-child > th{border-radius:0;}}}.", "-tbody > tr,tfoot > tr{&.warning > td{background-color:", " !important;}&.danger > td{background-color:", " !important;}&.success > td{background-color:", " !important;}&.info > td{background-color:", " !important;}}.", "-tbody > tr > td,tfoot > tr > td{&.warning{background-color:", " !important;}&.danger{background-color:", " !important;}&.success{background-color:", " !important;}&.info{background-color:", " !important;}}.", "-tbody > tr,tfoot > tr{> td{.ykb-currency-field{text-align:right;display:block;}}}", " ", " ", " ", " ", " ", ";", ";", ";.", "-tbody > tr.", "-placeholder{text-align:center;.", "-empty &{", ";text-align:center;color:", ";}&:hover{> td{background:", ";}}}.", "-thead > tr > th.", "-cell-scrollbar{position:relative;padding-right:1px;&:after{position:absolute;content:'';top:0px;bottom:0px;left:-1px;width:1px;background:", ";}}", ".table-action-button{margin:-2px;padding:0px;height:", ";border:2px solid transparent;overflow:hidden;&:hover,&:focus{outline:0;}&:disabled{", "{pointer-events:none;}}&:focus{border:2px solid rgba(77,144,254,0.5);background:#e8e8e8;}}", ";"], function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.theme.table.fontSize;
}, function (props) {
  return props.theme.table.backgroundColor;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.color;
}, function (props) {
  return props.theme.table.header.fontSize;
}, function (props) {
  return props.theme.table.header.fontWeight;
}, function (props) {
  return props.theme.table.header.textAlign;
}, function (props) {
  return props.theme.table.header.backgroundColor;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return !props.bordered && !props.footer && !props.summary ? "\n          &:last-of-type {\n            td {\n              border-bottom: none;\n            }\n          }\n      " : '';
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.header.color;
}, function (props) {
  return props.theme.table.header.fontSize;
}, function (props) {
  return props.theme.table.header.fontWeight;
}, function (props) {
  return props.theme.table.header.textAlign;
}, function (props) {
  return props.theme.table.header.backgroundColor;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.row.hover.backgroundColor;
}, function (props) {
  return props.theme.color.natural1;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.sticky.zIndex;
}, function (props) {
  return props.theme.table.borderColor;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.zebra.backgroundColor;
}, function (props) {
  return props.theme.table.zebra.color;
}, function (props) {
  return props.theme.table.row.hover.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.zebra.backgroundColor;
}, function (props) {
  return props.theme.table.zebra.color;
}, function (props) {
  return props.theme.table.row.hover.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.title.fontSize;
}, function (props) {
  return props.theme.table.title.fontWeight;
}, function (props) {
  return props.theme.table.title.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.colorPalette.neutral1;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.success6;
}, function (props) {
  return props.theme.colorPalette.neutral1;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.danger6;
}, function (props) {
  return props.theme.colorPalette.neutral1;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.theme.table.borderRadius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.warning1;
}, function (props) {
  return props.theme.color.danger1;
}, function (props) {
  return props.theme.color.success1;
}, function (props) {
  return props.theme.color.info1;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.warning1;
}, function (props) {
  return props.theme.color.danger1;
}, function (props) {
  return props.theme.color.success1;
}, function (props) {
  return props.theme.color.info1;
}, function (props) {
  return props.prefixCls;
}, selectionCss, expandableRow, sorterCss, filterCss, actionsCss, function (props) {
  return props.bordered && BorderedTable;
}, fixedCss, editableCss, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.table.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.table.header.backgroundColor;
}, _StyledButton.default, function (props) {
  return props.theme.table.action.height;
}, _StyledIcon.default, function (props) {
  return props.size && tableSize(props.size);
});
var MomoizedStyledTableContainer = /*#__PURE__*/_react.default.memo(StyledTableContainer);
var StyledTableComponent = function StyledTableComponent(_ref) {
  var prefixCls = _ref.prefixCls,
    children = _ref.children,
    className = _ref.className,
    theme = _ref.theme,
    minHeight = _ref.minHeight,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ')[0];
  return /*#__PURE__*/_react.default.createElement(MomoizedStyledTableContainer, (0, _extends2.default)({}, rest, {
    prefixCls: prefix,
    theme: theme,
    $minHeight: minHeight
  }), children(prefix));
};
var StyledTable = exports.StyledTable = (0, _ykbStyledComponents.styled)(StyledTableComponent).withConfig({
  componentId: "ykb-ui__sc-wkeoxa-2"
})([""]);
var StyledTablePaginationContainer = exports.StyledTablePaginationContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-wkeoxa-3"
})(["display:flex;width:100%;justify-content:flex-end;align-items:center;padding:", " 0;", ";"], function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
});